import { useLocation } from 'react-router-dom';
import { Link } from 'components/Link/Link';
import home from 'images/icons/whiteIcons/home.svg';
import './styles.scss';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');

    return (
        <div className="breadcrumbs">
            <Link href="/">
                <img src={home} alt="home" />
            </Link>
            <div className="breadcrumbs-dot"></div>
            {pathSegments.map((segment, index) => (
                <span key={segment} className="breadcrumbs-span">
                    <Link
                        className='body3'
                        href={`/${pathSegments.slice(0, index + 1).join('/')}`}
                    >
                        {segment.toUpperCase()}
                    </Link>
                    {index < pathSegments.length - 1 && <div className="breadcrumbs-dot margin-left"></div>}
                </span>
            ))}
        </div>
    );
};

export default Breadcrumbs;
